import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';

var ColorLabel = /*#__PURE__*/function (_Component) {
  _inherits(ColorLabel, _Component);

  var _super = _createSuper(ColorLabel);

  function ColorLabel() {
    _classCallCheck(this, ColorLabel);

    return _super.apply(this, arguments);
  }

  _createClass(ColorLabel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          tooltip = _this$props.tooltip,
          content = _this$props.content;
      var dotProps = Object.assign({}, this.props);
      delete dotProps.color;
      delete dotProps.tooltip;
      delete dotProps.content;
      delete dotProps.children;
      return /*#__PURE__*/React.createElement("div", _extends({
        className: "dot"
      }, dotProps), /*#__PURE__*/React.createElement("span", {
        className: "dot-content",
        style: {
          backgroundColor: color
        },
        "data-tooltip": tooltip
      }), /*#__PURE__*/React.createElement("span", {
        className: "text",
        style: {
          marginLeft: "5px"
        }
      }, content ? content : tooltip));
    }
  }]);

  return ColorLabel;
}(Component);

export default ColorLabel;